import Box, { BoxProps } from "@mui/material/Box";

interface TabPanelProps extends BoxProps {
  index: number;
  value: number;
}

export const TabPanel: React.FC<TabPanelProps> = (props) => {
  const { children, value, index, ...rest } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}>
      {value === index && <Box {...rest}>{children}</Box>}
    </div>
  );
};

export default TabPanel;
